import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { environment } from 'environments/environment';

@Component({
  selector: 'our-homes',
  templateUrl: './our-homes.component.html',
  styleUrls: ['./our-homes.component.scss']
})
export class OurHomesComponent implements OnInit {

  mobileQuery: MediaQueryList;
  private _mobileQueryListener: () => void;

  constructor(
    private media: MediaMatcher,
    private changeDetectorRef: ChangeDetectorRef
  ) {
    // 991 is the highest bootstrap medium size and sould be everything but "desktop"
    this.mobileQuery = this.media.matchMedia('(max-width: 991px)');
    this._mobileQueryListener = () => this.changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
  }

  ngOnInit() {}

  ngOnDestroy(): void {
    this.mobileQuery.removeListener(this._mobileQueryListener);
  }
}
